import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withRouter } from 'react-router-dom';
import {
    isLastStepSelector,
    activeStepSelector,
    errorSelector,
    isCompletingSelector,
    isQRActiveStep
} from '../selectors/wizardSelectors';
import { hasSetupSelector } from '../../app/selectors/appSelectors';
import { changeStep } from '../actions/wizardActions';
import Wizard from '../components/Wizard/Wizard';

const mapStateToProps = createStructuredSelector({
    isLastStep: isLastStepSelector,
    activeStep: activeStepSelector,
    error: errorSelector,
    isCompleting: isCompletingSelector,
    isQRActiveStep,
    hasSetup: hasSetupSelector
});

const mapDispatchToProps = { changeStep };

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Wizard));
